import { Injectable } from "@angular/core";

import { UserSessionService } from "../../../services/user-session/user-session.service";
import { WebservicesService } from "../../../services/webservices/webservices.service";
import { ConfigService } from "../../../services/config/config.service";
import { CustomerModel } from "../../../models/customer-model";
import { InAppBrowserObject } from "@ionic-native/in-app-browser/ngx";
import {
  GameLaunchParams,
  VendorAdapterInterface,
} from "./vendor-adapter-interface";
import { GameViewInterface, ODRController } from "../../odr-controller";
import { PlatformResponse } from "src/app/interfaces/webservices-interface";

@Injectable()
export class DGCAdapter implements VendorAdapterInterface {
  protected customer: CustomerModel;
  protected sessionToken: string;
  protected windowRef: InAppBrowserObject;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    protected config: ConfigService
  ) {
    this.userSession.getCustomer().subscribe((customer) => {
      this.customer = customer;
      this.sessionToken = this.userSession.getSessionToken();
    });
  }

  public setWindowRef(windowRef: InAppBrowserObject | GameViewInterface): void {
    this.windowRef = windowRef as InAppBrowserObject;
  }

  public getWindowRef(): InAppBrowserObject | GameViewInterface {
    return this.windowRef;
  }

  public windowStrategy() {
    return "inappbrowser";
  }

  public shouldDescendIntoDirs() {
    return false;
  }

  public getTagLayout(extGameParams: GameLaunchParams): Promise<Array<any>> {
    return this.config.isLoaded().then( () => {
      let jurisdiction = ODRController.clientAppJurisdiction(this.config.getClientApp());
      let tag = `${extGameParams.vendor}-${jurisdiction}-${extGameParams.extGameType}`;
      console.log("ODR: tag == "+tag);
      return [{ loc: "/gameflex/providers/dgc/#BUNDLENAME", tag: tag }];
    });
  }

  protected getParamsFromUrl(url: string) {
    url = decodeURI(url);
    if (typeof url === "string") {
      let params = url.split("?");
      let eachParamsArr = params[1].split("&");
      let obj = {};
      if (eachParamsArr && eachParamsArr.length) {
        eachParamsArr.map((param) => {
          let keyValuePair = param.split("=");
          let key = keyValuePair[0];
          let value = keyValuePair[1];
          obj[key] = value;
        });
      }
      return obj;
    }
  }
  protected getBaseHrefFromUrl(url: string) {
    url = decodeURI(url);
    let params = url.split("?");
    return params[0];
  }

  public credentials(p: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.webservices
        .get("games/launch-casino", {
          customer_id: this.customer ? this.customer.customerId : null,
          session_token: this.sessionToken ? this.sessionToken : null,
          vendor: "dgc",
          clientapp: this.config.getClientApp(),
          game_launcher_id: p.gameLaunchId,
          is_mobile: true,
          noredirect: true,
        })
        .subscribe(
          (resp: PlatformResponse<any>) => {
            if ("undefined" !== typeof resp.payload.href) {
              var decodedHref = decodeURI(resp.payload.href);
              var href = this.getBaseHrefFromUrl(decodedHref);
              var paramObj = this.getParamsFromUrl(decodedHref);

              paramObj["lobbyurl"] = "http://localhost:8080";
              paramObj["ios_origin"] = "http://localhost:8080";

              const searchParams = new URLSearchParams();
              Object.keys(paramObj).forEach((key) =>
                searchParams.append(key, paramObj[key])
              );
              var newParams = searchParams.toString();

              resp.payload.href = href + "?" + newParams;
              console.log("ODR: dgc.ts: final href == ", resp.payload.href);
              resolve(Object.assign(p, resp.payload));
            }
          },
          (err: any) => {
            console.log("ODR: dgc.ts: games/launch-casino error: ", err);
            reject(err);
          }
        );
    });
  }

  public launchODR(windowRef: InAppBrowserObject, gamePrms: any) {
    console.log("ODR: dgc.ts: launchODR();");
    this.windowRef = windowRef;

    var url = gamePrms.href;
    this.evaluateJavascript(`
            window.location.href = '${url}';
        `);
    return windowRef;
  }

  public evaluateJavascript(js: string): Promise<any> {
    if (this.windowRef) {
      return this.windowRef.executeScript({
        code: js,
      });
    } else {
      return Promise.reject("ODR: everi.ts: invalid windowRef");
    }
  }

  public onGameClosed(windowRef: InAppBrowserObject, closedCb: () => void) {
    var ticket: number = 1; // prevent closeCb from being called by multiple close events

    let intervalID = setInterval(() => {
      windowRef
        .executeScript({ code: "window._game_has_closed" })
        .then((val) => {
          if (val[0]) {
            clearInterval(intervalID);
            if (!--ticket) {
              console.log("ODR: internal.ts: onGameClosed: _game_has_closed");
              windowRef.close();
              closedCb();
            } else {
              ticket++;
            }
          }
        });
    }, 500);
    windowRef.on("exit").subscribe((event) => {
      if (!--ticket) {
        console.log("ODR: dgc.ts: onGameClosed");
        closedCb();
      } else {
        ticket++;
      }
    });
  }
}
